import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsPanel = ({ stablecoinValue, m2Value, ratio }) => {
  const stats = [
    {
      id: 'stablecoin-market-cap',
      label: 'Total Stablecoin Market Cap',
      value: `$${(stablecoinValue / 1e9)?.toFixed(2)}B`,
      icon: 'CircleDollarSign',
      color: '#D08A2A',
      textColor: 'text-[#D08A2A]',
      bgColor: 'bg-[#D08A2A]/10',
      change: '+2.4%',
      changeType: 'positive'
    },
    {
      id: 'm2-supply',
      label: 'US M2 Money Supply',
      value: `$${(m2Value / 1e12)?.toFixed(2)}T`,
      icon: 'Landmark',
      color: 'var(--color-muted-foreground)',
      textColor: 'text-muted-foreground',
      bgColor: 'bg-muted',
      change: '+0.8%',
      changeType: 'positive'
    },
    {
      id: 'ratio',
      label: 'Stablecoin/M2 Ratio',
      value: `${ratio?.toFixed(4)}%`,
      icon: 'Percent',
      color: 'var(--color-primary)',
      textColor: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+1.6%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {stats?.map((stat) => (
        <div 
          key={stat?.id}
          className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border transition-all duration-300 hover:shadow-md hover:border-primary/20"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
            
            <div className={`
              flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium
              ${stat?.changeType === 'positive' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}
            `}>
              <Icon 
                name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                size={12} 
                color="currentColor" 
              />
              <span>{stat?.change}</span>
            </div>
          </div>

          <div className="space-y-1">
            <p className="text-xs md:text-sm text-muted-foreground">
              {stat?.label}
            </p>
            <p className={`text-2xl md:text-3xl lg:text-4xl font-semibold ${stat?.textColor}`}>
              {stat?.value}
            </p>
          </div>

          <div className="mt-4 pt-4 border-t border-border">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Clock" size={12} color="var(--color-muted-foreground)" />
              <span>Updated 5 minutes ago</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;